<template>
	<el-carousel :height="bannerHeight" :autoplay="true" :interval="8000" indicator-position="none">
		<el-carousel-item v-for="(banner, index) in bannerList" :key="index">
			<div class="banner-box">
				<img class="banner-img" :src="banner.src" @click="toPage(banner)" />
				<div class="banner-text">
					<div class="banner-title">
						{{ banner.title }}
					</div>
					<div class="banner-info" :class="{ 'banner-info-border': banner.info.length > 1 }">
						<div v-for="info in banner.info" class="banner-info-item">
							{{ info }}
						</div>
					</div>
				</div>
			</div>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
import { config } from '../../../constant/config.js'
export default {
	data() {
		return {
			bannerHeight: '570px',
			bannerList: [config.banner[0]]
		}
	},
	created() {
		setTimeout(() => {
			this.bannerList = config.banner
		}, 2000)
	},
	mounted() {
	},
	methods: {
		toPage(item) {
			this.$router.push(item.url)
		}
	},

}
</script>

<style lang="less" scoped>
// @import '@/assets/style/mixins.less';

.banner-box {
	height: 100%;
	width: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
	cursor: default;

	.banner-img {
		width: 100%;
		height: 100%;
		animation-name: scaleImage;
		animation-delay: 0.6s;
		animation-duration: 0.6s;
		animation-fill-mode: forwards;
		// object-fit: cover;
		object-fit: contain;
		object-fit: fill;
		font-family: 'object-fit:cover;';
	}


	.banner-text {
		position: absolute;
		bottom: 0;
		padding-bottom: 70px;
		padding-left: 70px;
		color: @mainTextColor;
		z-index: 50;


		.banner-title {
			font-size: 50px;
			margin-bottom: 10px;
		}

		.banner-info {
			display: flex;
			flex-direction: column;
			font-size: 22px;

			.banner-info-item {
				margin: 10px 0px;
			}
		}

		.banner-info-border {
			border-left: 2px solid @mainColor;
			padding-left: 20px;
		}
	}

	@media @mobile {
		.banner-text {
			padding-bottom: 0px;
			padding-left: 16px;

			.banner-title {
				font-size: 40px;

			}

			.banner-info {
				font-size: 14px;
			}
		}

		.banner-img {
			object-fit: cover;
		}
	}


	&::after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		left: -68px;
		width: calc(100% + 136px);
		height: 80%;
		background: -webkit-gradient(linear, left top, left bottom, from(rgba(46, 46, 56, 0)), to(#2e2e38));
		background: linear-gradient(180deg, rgba(46, 46, 56, 0) 0%, #2e2e38 100%);
		z-index: 20;
		pointer-events: none;
	}
}

@keyframes scaleImage {
	0% {
		transform: scale(1);
	}

	100% {
		transform: scale(1.05);
	}
}
</style>